<template>
  <div class="badge">
    <span
      v-if="label"
      class="sr-only"
    >
      {{ label }}
    </span>
    {{ text }}
  </div>
</template>

<script>

export default {
  name: 'Badge',
  props: {
    text: {
      type: [String, Number],
      required: false,
      default () {
        return ''
      },
    },
    label: {
      type: [String, Number],
      required: false,
      default () {
        return ''
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
